import { IResourceComponentsProps } from '@pankod/refine-core'

import { QuestionTableList } from 'components/questions'
import { CompletionStatus } from 'helpers'

export const QuestionsList: React.FC<IResourceComponentsProps> = () => {
  return (
    <>
      <QuestionTableList />
    </>
  )
}
